import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {FiDribbble} from 'react-icons/fi'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href="https://linkedin.com/in/abhishek-khandelwal-dev/" target="_blank"><BsLinkedin/></a>
      <a href="https://github.com/abhishekkh47" target="_blank"><FaGithub/></a>
      <a href="https://dribble.com" target="_blank"><FiDribbble/></a>
    </div>
  )
}

export default HeaderSocials
